class Accordion extends HTMLElement {
  constructor() {
    super();

    this.listeners();
  }

  listeners() {
    let accordions = document.querySelectorAll("accordion-wrapper");

    accordions.forEach((el) => {
      const accordionHeaders = el.querySelectorAll(".accordion__header");
      const openFirstItem = el.getAttribute("data-open-first") === "true";

      if (openFirstItem === true) {
        const firstItem = el.querySelector(".accordion__item");

        firstItem.classList.add("accordion__item--open");
      }

      accordionHeaders.forEach(el => el.addEventListener("click", this.accordionClickEvent));
    });

    const codeApplied = document.querySelector('.discount-code__applied-code');

    if(codeApplied) {
      document.querySelector('.js-popout-cart .accordion__item').classList.add('accordion__item--open')
      document.querySelector('.js-popout-cart .accordion__content').style.height = "auto";
    }
  }

  accordionClickEvent() {
    const accordionItem = this.closest(".accordion__item");
    const accordionContainer = this.closest("accordion-wrapper");
    const mobileOnly = accordionContainer.getAttribute("data-mobile-only") === "true";
    const touchOnly = accordionContainer.getAttribute("data-touch-only") === "true";

    const mediaQuery = window.matchMedia("(max-width: 989px)");

    if (mobileOnly || touchOnly) {
      if (mediaQuery.matches) Accordion.toggleStates(accordionContainer, accordionItem);
    } else {
      Accordion.toggleStates(accordionContainer, accordionItem);
    }
  }

  // Toggle active states of clicked accordion
  static toggleStates(container, item) {
    const wrapper = container.closest(".js-accordion-container");
    const parent = container.parentNode;
    const accordionItems = (wrapper || parent).querySelectorAll(".accordion__item:not(.accordion__item--disabled)");
    const autoClose = container.getAttribute("data-auto-close") === "true";

    let isDelay = false;

    if (!item.classList.contains("accordion__item--open")) {
      if (autoClose === true) {
        accordionItems.forEach(el => {
          if (el.classList.contains("accordion__item--open")) {
            this.closeAccordion(el);

            isDelay = true;
          }
        });
      }

      // Duration of animation
      setTimeout(() => this.openAccordion(item), isDelay ? 250 : 0);
    } else {
      this.closeAccordion(item);
    }
  }

  static openAccordion(el, openFirst) {
    el.classList.add("accordion__item--open");

    const content = el.querySelector(".accordion__content");

    // Set properties to calculate height whilst hiding element
    content.style.width = getComputedStyle(content).width;
    content.style.position = 'absolute';
    content.style.visibility = 'hidden';
    content.style.height = 'auto';

    const height = getComputedStyle(content).height;

    // Reset properties used above to calculate height
    content.style.width = null;
    content.style.position = null;
    content.style.visibility = null;
    content.style.height = "0";

    // Force repaint
    getComputedStyle(content).height;
    requestAnimationFrame(() => content.style.height = height);

    content.addEventListener("transitionend", () => {
      if (el.classList.contains("accordion__item--open")) content.style.height = "auto";
    });
  }

  static repositionViewport(el) {
    const isMobile = window.matchMedia("(max-width: 749px)").matches;
    const offset = document.documentElement.scrollTop;
    const target = el.getBoundingClientRect().top;
    const header = document.documentElement.style.getPropertyValue("--header-height");

    let stickyHeader = 0

    if (!isMobile) stickyHeader = document.querySelector(".sticky-bag").getBoundingClientRect().top;

    const y = target + offset - header.replace("px", "") - stickyHeader;

    requestAnimationFrame(() => window.scrollTo({ top: y , behavior: "smooth" }));
  }

  static closeAccordion(el) {
    el.classList.remove("accordion__item--open");

    const content = el.querySelector(".accordion__content");

    content.style.height = getComputedStyle(content).height;

    // Force repaint
    getComputedStyle(content).height;

    requestAnimationFrame(() => content.style.height = "0");
  }
}

if (!customElements.get("accordion-wrapper")) customElements.define("accordion-wrapper", Accordion);
